<div class="logo">
  <ng-container *ngIf="!isTgaTheme">
    <img [src]="imgSrc" class="logo__img d-none d-inline-block-md">
    <img  class="d-none-md d-inline-block" src="../../../../assets/images/MADAR-Icon.svg" />
  </ng-container>

  <img *ngIf="isTgaTheme" style="width: 90px;height:60px" class="d-inline-block" src="../../../../assets/images/Saudi_TGA_Logo.svg" />
</div>
